import { render, staticRenderFns } from "./MarketChange.vue?vue&type=template&id=6104f914&scoped=true"
import script from "./MarketChange.vue?vue&type=script&lang=js"
export * from "./MarketChange.vue?vue&type=script&lang=js"
import style0 from "./MarketChange.vue?vue&type=style&index=0&id=6104f914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6104f914",
  null
  
)

export default component.exports